/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<797c70e3fd8b62160cfa695a831e4c8b>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type editorViewRendererFragment$data = {
  readonly adf: string | null | undefined;
  readonly elementType: {
    readonly mediaConfig: {
      readonly asapIssuer: string;
      readonly mediaCollectionName: string;
      readonly mediaToken: string;
      readonly mediaUrl: string;
    };
  };
  readonly " $fragmentType": "editorViewRendererFragment";
};
export type editorViewRendererFragment$key = {
  readonly " $data"?: editorViewRendererFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editorViewRendererFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "helpCenterAri"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "editorViewRendererFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "adf",
      "storageKey": null
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "concreteType": "HelpLayoutAtomicElementType",
        "kind": "LinkedField",
        "name": "elementType",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": null,
              "args": [
                {
                  "kind": "Variable",
                  "name": "parentAri",
                  "variableName": "helpCenterAri"
                }
              ],
              "concreteType": "HelpLayoutMediaConfig",
              "kind": "LinkedField",
              "name": "mediaConfig",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaCollectionName",
                    "storageKey": null
                  },
                  "action": "THROW",
                  "path": "elementType.mediaConfig.mediaCollectionName"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaToken",
                    "storageKey": null
                  },
                  "action": "THROW",
                  "path": "elementType.mediaConfig.mediaToken"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "mediaUrl",
                    "storageKey": null
                  },
                  "action": "THROW",
                  "path": "elementType.mediaConfig.mediaUrl"
                },
                {
                  "kind": "RequiredField",
                  "field": {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "asapIssuer",
                    "storageKey": null
                  },
                  "action": "THROW",
                  "path": "elementType.mediaConfig.asapIssuer"
                }
              ],
              "storageKey": null
            },
            "action": "THROW",
            "path": "elementType.mediaConfig"
          }
        ],
        "storageKey": null
      },
      "action": "THROW",
      "path": "elementType"
    }
  ],
  "type": "HelpLayoutEditorElement",
  "abstractKey": null
};

(node as any).hash = "7185bbf55e8e3c72d62297a3cc6f9712";

export default node;
